import { EventKey } from '../enums';
export const WithTrack = (Base) => {
    return class PlayerWithTrack extends Base {
        setSubtitlesTrack(track) {
            this.adapter.setSubtitlesTrack(track);
        }
        setAudioTrack(track) {
            this.adapter.setAudioTrack(track);
        }
        triggerEvent(event) {
            super.triggerEvent(event);
            switch (event.type) {
                case EventKey.SELECTED_AUDIO_TRACK_CHANGED:
                    this.selectedAudioTrack = event.targetTrack;
                    break;
                case EventKey.SELECTED_SUBTITLES_TRACK_CHANGED:
                    this.selectedSubtitlesTrack = event.targetTrack;
                    break;
                case EventKey.AVAILABLE_AUDIO_TRACKS_CHANGED:
                    this.availableAudioTracks = event.tracks;
                    break;
                case EventKey.AVAILABLE_SUBTITLES_TRACKS_CHANGED:
                    this.availableSubtitlesTracks = event.tracks;
                    break;
                default:
                    break;
            }
        }
        availableAudioTracks = [];
        availableSubtitlesTracks = [];
        selectedAudioTrack = null;
        selectedSubtitlesTrack = null;
    };
};
